import script from "./CallsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CallsTable.vue?vue&type=script&setup=true&lang=js"

import "./CallsTable.vue?vue&type=style&index=0&id=05b0e7c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b0e7c7"]])

export default __exports__